// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--gfDfm","link":"_9e1425b4d3--link--_NdBL"};